import styled from 'styled-components'

export const HubWrapper = styled.div`
  > div {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    margin-top: 2.25rem;

    h2 {
      color: #767676;
      font-size: 1.5rem;
      font-weight: 600;
      line-height: normal;
    }

    .tutorial-row {
      display: flex;
      flex-direction: row;
      gap: 1.5rem;
      flex-wrap: wrap;

      .tutorial-card {
        display: flex;
        min-width: 15.875rem;
        padding: 1rem;
        flex-direction: column;
        align-items: flex-start;
        gap: 2rem;
        flex: 1 0 0;
        border-radius: 0.5rem;
        border: 1px solid rgba(0, 0, 0, 0.15);
        background: #fff;
        box-shadow: 0px 3px 12px 0px rgba(47, 43, 61, 0.14);

        img {
          width: 100%;
          aspect-ratio: 16/9;
          object-fit: cover;
          border-radius: 0.5rem;
        }

        .tutorial-info {
          width: 100%;
          display: flex;
          flex-direction: column;
          gap: 0.5rem;

          .tutorial-title {
            display: -webkit-box;
            color: #2f2b3de5;
            font-size: 1.125rem;
            font-style: normal;
            font-weight: 500;
            line-height: 1.75rem;
            align-self: stretch;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }

          .tutorial-submodule {
            width: max-content;
            display: flex;
            padding: 0.375rem 0.5rem;
            justify-content: center;
            align-items: center;
            gap: 0.5rem;

            color: #00bad1;
            font-size: 0.8125rem;
            font-style: normal;
            font-weight: 600;
            line-height: 1.25rem;

            border-radius: 0.25rem;
            border: 1px solid #00bad1;
            background: rgba(0, 186, 209, 0.08);
          }
        }
      }
    }

    .module-grid {
      display: grid;
      grid-gap: 1.5rem;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: auto;

      > a:last-child:nth-child(odd) {
        grid-column-start: 1;
        grid-column-end: 3;
      }

      .module-card {
        display: flex;
        padding: 1.5rem;
        flex-direction: column;
        align-items: flex-start;
        gap: 2rem;
        flex: 1 0 0;

        border-radius: 0.5rem;
        border: 1px solid rgba(0, 0, 0, 0.15);
        background: #fff;

        .module-icon {
          display: flex;
          width: 3rem;
          height: 3rem;
          padding: 0.5rem;
          justify-content: center;
          align-items: center;

          border-radius: 0.375rem;
          background: linear-gradient(
            270deg,
            rgba(115, 103, 240, 0.7) 0%,
            #7367f0 100%
          );
          box-shadow: 0px 2px 6px 0px rgba(115, 103, 240, 0.3);
        }

        .module-title {
          color: #2f2b3de5;
          font-size: 1.125rem;
          font-style: normal;
          font-weight: 500;
          line-height: 1.75rem;
        }
      }
    }
  }
`

export const ModuleWrapper = styled.div`
  > div {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    margin-top: 2.25rem;

    h2 {
      color: #767676;
      font-size: 1.5rem;
      font-weight: 600;
      line-height: normal;
    }

    .tutorial-grid {
      display: flex;
      flex-direction: row;
      gap: 1.5rem;
      flex-wrap: wrap;

      .tutorial-card {
        display: flex;
        height: 20rem;
        width: 20rem;
        max-width: 20rem;
        min-width: 20rem;
        padding: 1rem;
        flex-direction: column;
        align-items: flex-start;
        gap: 2rem;
        flex: 1 0 0;
        border-radius: 0.5rem;
        border: 1px solid rgba(0, 0, 0, 0.15);
        background: #fff;
        box-shadow: 0px 3px 12px 0px rgba(47, 43, 61, 0.14);

        img {
          width: 100%;
          aspect-ratio: 16/9;
          object-fit: cover;
          border-radius: 0.5rem;
        }

        .tutorial-info {
          width: 100%;
          display: flex;
          flex-direction: column;
          gap: 0.5rem;

          .tutorial-title {
            display: -webkit-box;
            color: #2f2b3de5;
            font-size: 1.125rem;
            font-style: normal;
            font-weight: 500;
            line-height: 1.75rem;
            align-self: stretch;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }

          .tutorial-submodule {
            width: max-content;
            display: flex;
            padding: 0.375rem 0.5rem;
            justify-content: center;
            align-items: center;
            gap: 0.5rem;

            color: #00bad1;
            font-size: 0.8125rem;
            font-style: normal;
            font-weight: 600;
            line-height: 1.25rem;

            border-radius: 0.25rem;
            border: 1px solid #00bad1;
            background: rgba(0, 186, 209, 0.08);
          }
        }
      }
    }
  }
`

export const TutorialWrapper = styled.div`
  > div {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    margin-top: 2.25rem;

    h2 {
      color: #767676;
      font-size: 1.5rem;
      font-weight: 600;
      line-height: normal;
    }

    .content-row {
      display: flex;
      flex-direction: row;
      gap: 2.25rem;

      .content-card {
        width: 100%;
        height: fit-content;
        display: flex;
        padding: 2rem;
        flex-direction: column;
        justify-content: start;
        align-items: start;
        gap: 1rem;

        border-radius: 0.5rem;
        background: #fff;

        > h1 {
          color: #24292e;

          font-size: 1.75rem;
          font-style: normal;
          font-weight: 500;
          line-height: 2.625rem;
        }

        img {
          width: 100%;
          aspect-ratio: 16/9;
          object-fit: cover;
        }

        .video-container {
          width: 100%;
          aspect-ratio: 16/9;
        }
      }

      .content-aside {
        width: 25%;
        display: flex;
        flex-direction: column;
        gap: 2.25rem;

        .related-card {
          display: flex;
          width: 100%;
          padding: 1rem;
          flex-direction: column;
          justify-content: center;
          align-items: start;
          gap: 1rem;
          border-radius: 0.5rem;
          background: #fff;

          h3 {
            color: #2f2b3de5;
            font-size: 1.125rem;
            font-style: normal;
            font-weight: 500;
            line-height: 1.75rem;
          }

          .tutorial-card {
            display: flex;
            padding: 0.5rem 1rem;
            flex-direction: column;
            align-items: flex-start;
            gap: 0.75rem;
            align-self: stretch;
            border-left: 2px solid rgba(0, 0, 0, 0.15);

            color: #2f2b3db2;
            font-size: 0.9375rem;
            font-style: normal;
            font-weight: 500;
            line-height: 1.375rem;

            .tutorial-submodule {
              width: max-content;
              display: flex;
              padding: 0.375rem 0.5rem;
              justify-content: center;
              align-items: center;
              gap: 0.5rem;

              color: #00bad1;
              font-size: 0.8125rem;
              font-style: normal;
              font-weight: 600;
              line-height: 1.25rem;

              border-radius: 0.25rem;
              border: 1px solid #00bad1;
              background: rgba(0, 186, 209, 0.08);
            }
          }
        }

        .modules-card {
          display: flex;
          width: 100%;
          padding: 1rem;
          flex-direction: column;
          justify-content: center;
          align-items: start;
          gap: 1rem;
          border-radius: 0.5rem;
          background: #fff;

          h3 {
            color: #2f2b3de5;
            font-size: 1.125rem;
            font-style: normal;
            font-weight: 500;
            line-height: 1.75rem;
          }

          .module-card {
            display: flex;
            align-items: flex-start;
            gap: 0.75rem;
            align-self: stretch;

            color: #2f2b3de5;
            font-size: 1.125rem;
            font-style: normal;
            font-weight: 500;
            line-height: 1.75rem;

            .module-icon {
              display: flex;
              width: 2rem;
              height: 2rem;
              padding: 0.33331rem;
              justify-content: center;
              align-items: center;
              gap: 0.33331rem;
              aspect-ratio: 1/1;
              border-radius: 0.25rem;
              background: linear-gradient(
                270deg,
                rgba(115, 103, 240, 0.7) 0%,
                #7367f0 100%
              );
              box-shadow: 0px 1.333px 4px 0px rgba(115, 103, 240, 0.3);
            }
          }
        }
      }
    }
  }
`

export const CreateWrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 2.5rem;
  flex-direction: column;
  align-items: flex-start;
  gap: 2rem;
  align-self: stretch;
  border-radius: 0.75rem;
  background: #fff;
  margin-top: 2.25rem;

  .context-menu {
    display: flex;
    align-items: center;
    gap: 1rem;
    align-self: stretch;

    a {
      display: flex;
      width: 2rem;
      height: 2rem;
      padding: 0.5rem;
      justify-content: center;
      align-items: center;
      border-radius: 9999px;
      border: 1px solid var(--gray-200, #e2e8f0);
    }

    h2 {
      color: #000;
      font-size: 1.375rem;
      font-style: normal;
      font-weight: 600;
      line-height: 2rem;
      margin-bottom: 0;
    }
  }

  .tutorial-inputs {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;

    .simple-input {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 0.5rem;
      align-self: stretch;

      label {
        color: rgba(0, 0, 0, 0.85);
        font-size: 1rem;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }

      input {
        width: 100%;
        display: flex;
        height: 3rem;
        padding: 1rem;
        align-items: center;
        gap: 0.5rem;
        align-self: stretch;
        border-radius: 0.25rem;
        border: 1px solid #d8d8d8;
      }
    }

    .double-select {
      display: flex;
      flex-direction: row;
      justify-content: stretch;
      gap: 1rem;

      > div {
        width: 100%;
      }
    }

    .select-input {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      label {
        color: rgba(0, 0, 0, 0.85);
        font-size: 1rem;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }
    }

    .file-input {
      display: flex;
      padding: 1rem;
      flex-direction: column;
      align-items: flex-start;
      gap: 0.5rem;
      align-self: stretch;
      border: 2px dashed #c4c4c4;
      background: #fcfcfc;
    }
  }

  .markdown-input {
    display: flex;
    width: 100%;

    > div {
      width: 100%;
    }

    .bytemd-fullscreen {
      z-index: 99999;
    }
  }

  .action-buttons {
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 1rem;
    justify-content: space-between;

    > div {
      display: flex;
      gap: 1rem;
      justify-content: center;
      align-items: center;
    }

    button,
    a {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0.625rem 1rem;
      gap: 0.5rem;
      border: none;
      border-radius: 0.3125rem;
      background: transparent;
      text-align: center;
      font-size: 0.875rem;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      letter-spacing: 0.025rem;

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }

    .delete-button {
      color: #ff4c51;
    }

    .cancel-button {
      border: 1px solid #979797;
      color: #979797;
    }

    .save-button {
      background: #61c478;
      color: #ffffff;
    }
  }
`

export const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
  margin-top: 2.25rem;

  > div {
    width: 100%;
    animation: skeleton-loading 1s infinite alternate;
  }

  > div:nth-child(even) {
    height: 15rem;
  }

  > div:nth-child(odd) {
    height: 8rem;
  }

  @keyframes skeleton-loading {
    0% {
      background-color: hsl(200, 20%, 80%);
    }
    100% {
      background-color: hsl(200, 20%, 95%);
    }
  }
`

export const TutorialTitleCell = styled.a`
  display: flex;
  justify-content: center;
  color: #161616;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.0625rem;
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;

  &:hover {
    color: #161616;
  }
`

export const SubmoduleTag = styled.div`
  width: max-content;
  display: flex;
  padding: 0.375rem 0.5rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;

  color: #00bad1;
  font-size: 0.8125rem;
  font-style: normal;
  font-weight: 600;
  line-height: 1.25rem;

  border-radius: 0.25rem;
  border: 1px solid #00bad1;
  background: rgba(0, 186, 209, 0.08);
`

export const CreateLink = styled.a`
  display: flex;
  padding: 0.625rem 1rem;
  align-items: center;
  gap: 0.5rem;
  border-radius: 0.3125rem;
  background: #776cf1;
  color: #fff;

  &:hover {
    background: #5f4bd1;
    color: #fff;
  }
`

export const ConfirmDeletion = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  gap: 1rem;

  .info-container {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }

  .confirm-text {
    color: #5e5873;
    text-align: center;
    font-size: 1.3125rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .info-text {
    color: #6e6b7b;
    text-align: center;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.3125rem;
  }

  .title-text {
    color: #a8a8a8;
    text-align: center;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.3125rem;
  }

  .action-container {
    display: flex;
    gap: 0.5rem;

    button {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0.625rem 1rem;
      gap: 0.5rem;
      border: none;
      border-radius: 0.3125rem;
      background: transparent;
      text-align: center;
      font-size: 0.875rem;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      letter-spacing: 0.025rem;
    }

    .delete-button {
      background: #ff4c51;
      color: #fff;
    }

    .cancel-button {
      border: 1px solid #979797;
      color: #979797;
    }
  }
`
